import React from "react";
import Social from './Social';

const highlights = [
  {
    title: 'Builder mindset',
    detail:
      'I love turning ideas into real products — taking projects from messy beginnings to polished, production-ready tools people actually enjoy using.',
  },
  {
    title: 'Calm, structured problem-solving',
    detail:
      'I’m methodical under pressure: I break problems down, validate assumptions, and keep progress steady even when the path isn’t obvious.',
  },
  {
    title: 'Human-first collaboration',
    detail:
      'I’m direct but kind — I value clear communication, ownership, and helping teams do their best work together.',
  },
];

const About = () => {
  const [isDark, setIsDark] = React.useState(false);

  React.useEffect(() => {
    const stored = localStorage.getItem('theme');
    const nextIsDark = stored ? stored === 'dark' : true;
    setIsDark(nextIsDark);
    document.body.dataset.theme = nextIsDark ? 'dark' : 'light';
  }, []);

  const toggleTheme = () => {
    setIsDark((prev) => {
      const next = !prev;
      document.body.dataset.theme = next ? 'dark' : 'light';
      localStorage.setItem('theme', next ? 'dark' : 'light');
      return next;
    });
  };

  return (
    <section className="about__container about-section">
      <button className="theme-toggle" type="button" onClick={toggleTheme}>
        {isDark ? 'Light mode' : 'Dark mode'}
      </button>
      <div className="about-hero editorial">
        <div className="about-copy">
          <p className="resume-eyebrow">ABOUT</p>
          <h2 className="about-title">Jushita Rahman</h2>
          <p className="about-role">Senior Software Engineer</p>
          <div className="about-logos">
            <span className="logo-swap">
              <img className="logo-amazon logo-light" src="/assets/Amazon.svg" alt="Amazon" />
              <img
                className="logo-amazon logo-dark"
                src="/assets/amazon-dark-mode.png"
                alt="Amazon"
              />
            </span>
            <img className="logo-walmart" src="/assets/walmart.svg" alt="Walmart Global Tech" />
            <img className="logo-fidelity" src="/assets/Fidelity.png" alt="Fidelity Investments" />
          </div>
          <div className="about-image-frame">
            <img className="about-image" src="/assets/about.png" alt="Jushita Rahman" />
          </div>
          <p className="about-text">
            I’m driven by solving meaningful problems, shipping practical solutions, and
            continuously learning — both in technology and in life.
          </p>
          <p className="about-text">
            Over the past several years, I’ve worked across large-scale platforms and data-driven
            products, developing forecasting infrastructure, automation systems, and full-stack
            applications used by teams to make critical business decisions. I enjoy working at the
            intersection of backend systems, cloud infrastructure, and clean, thoughtful frontend
            design — turning messy problems into practical solutions.
          </p>
          <p className="about-text">
            Beyond code, I’m naturally curious and love building things, whether it’s a new product
            idea, a garden full of climbing roses, or a side project that scratches a creative itch.
            I enjoy travel, reading psychological thrillers, designing cozy spaces at home, and
            spending time with my cats. These hobbies keep me grounded and often inspire how I
            approach engineering — with creativity, patience, and attention to detail.
          </p>
          <p className="about-text">
            I’m always excited to work on problems where technology creates real impact, and I enjoy
            collaborating with people who care deeply about what they build.
          </p>
          <div className="about-actions">
            <a className="resume-button primary" href="/home/resume">
              View Resume
            </a>
            <a className="resume-button ghost" href="/home/skills">
              Explore Skills
            </a>
          </div>
        </div>
      </div>

      <div className="about-highlights">
        {highlights.map((item) => (
          <article key={item.title} className="about-card">
            <h3>{item.title}</h3>
            <p>{item.detail}</p>
          </article>
        ))}
      </div>

      <div className="social_container">
        <Social />
      </div>
    </section>
  );
};

export default About;
